module["exports"] = [
  "Bhaktapur",
  "Biratnagar",
  "Birendranagar",
  "Birgunj",
  "Butwal",
  "Damak",
  "Dharan",
  "Gaur",
  "Gorkha",
  "Hetauda",
  "Itahari",
  "Janakpur",
  "Kathmandu",
  "Lahan",
  "Nepalgunj",
  "Pokhara"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/address/city.js
 ** module id = 785
 ** module chunks = 0
 **/